/**
 * @Copyright 2014-2019 DataVoke, Inc. All rights reserved.
 */

'use strict';

import * as viewLib from './view';
import * as dynamicValueLib from './dynamicValue';
import * as recordLib from './record';
import * as packageLib from './package';
import * as userLib from './user';
import * as gridRecordLib from './gridRecord';
import * as gridValueLib from './gridValue';
import * as styleLib from './style';
import * as entityBase from './entitybase';
import * as validation from './validationRule';
import * as extensionLib from './extensions';

export const view = viewLib;
export const View = viewLib.View;
export const dynamicValue = dynamicValueLib;
export const DynamicValue = dynamicValueLib.DynamicValue;
export const record = recordLib;
export const Record = recordLib.Record;
export const Package = packageLib.PackageEntity;
export const user = userLib;
export const User = userLib.User;
export const gridRecord = gridRecordLib;
export const GridRecord = gridRecordLib.GridRecord;
export const gridValue = gridValueLib;
export const GridValue = gridValueLib.GridValue;
export const style = styleLib;
export const Style = styleLib.Style;
export const ClientProperties = entityBase.ClientProperties;
export const validationRule = validation;
export const extensions = extensionLib;

export {PropertyEntity as Property} from './property';
export {CategoryEntity as Category} from './category';
export {RecordTypeEntity as RecordType} from './recordType';
